import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';

const LPIntroductionScreen = ({ onClick, withSeeDemoLink }) => {
  const onSeeDemoClick = () => {
    window.location.href = '/instant-demo';
  };

  return (
    <>
      <h2 className="alternate-questions__header margin-bottom-md-20px">
        Interested in affordable, modern payroll and benefits?
      </h2>
      <Button
        className="btn btn-primary margin-top-10px full-width"
        label="Get started"
        onClick={onClick}
      />
      <div className="alternate-questions__divider">or</div>
      {withSeeDemoLink && (
        <Button
          className="btn btn-secondary margin-top-10px full-width"
          label="Try a free demo"
          onClick={onSeeDemoClick}
        />
      )}
    </>
  );
};

LPIntroductionScreen.propTypes = {
  onClick: PropTypes.func.isRequired,
  withSeeDemoLink: PropTypes.bool.isRequired,
};

export default LPIntroductionScreen;
